<template lang="html">
  <div
    v-if="active"
    class="publication-band"
    :style="`background-color: ${color}; color: ${textColor}; ${left ? 'left: 0' : 'right: 0'}; ${second ? 'top: 23px !important' : ''}; ${bottom ? 'bottom: 10px !important' : 'top: 0'}`">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean,
    color: String,
    text: String,
    textColor: String,
    left: Boolean,
    second: Boolean,
    bottom: Boolean
  }
}
</script>

<style lang="css" scoped>
  .publication-band {
    font-weight: bold;
    font-size: 0.85rem;
    line-height: 1.45rem;
    padding: 0 0.5rem;
    position: absolute;
    z-index: 1;
    box-shadow: 1px 2px 2px #888888;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/PublicationBand.vue